import { ApplicationStore } from './global/ApplicationStore';
import { AlertStore } from './global/alert/AlertStore';
import { StoreStore } from '../views/store/StoreStore';
import { CartStore } from '../views/cart/CartStore';

export class RootStore {
  public readonly applicationStore: ApplicationStore;
  public readonly alertStore: AlertStore;
  public readonly storeStore: StoreStore;
  public readonly cartStore: CartStore;

  constructor() {
    this.alertStore = new AlertStore(this);
    this.applicationStore = new ApplicationStore(this);
    this.storeStore = new StoreStore();
    this.cartStore = new CartStore();
  }
}
